import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from '../../store/contexts';

export const UserLayout = () => {
    const user = useSelector((state) => state.auth.user);

    if (user === null) {
        return <Navigate to="/login" replace />;
    }

    return (
        <UserContext.Provider value={{ user }}>
            <Outlet />
        </UserContext.Provider>
    );
};
